<template>
  <div class="sidebarWindow bigSidebarWindow">
    <div class="sidebarWindowTitle">
      <span>{{ $t("Search") }}</span>
      <span @click="closeSearch" class="closeSidebarArrow">
        <CloseWindowSVG />
      </span>
    </div>
      <div>
        <app-toggle-buttons
          :buttons="toggleButtons"
          :value="filterOption"
          @input="filterOption = $event"
        />
        <div
          class="mx-auto mt-3  input-field-container"
          v-if="filterOption === 'other'"
        >
          <treeselect
            v-model="selectedLayer"
            :options="typeOptions"
            :normalizer="objectTypeNormalizer"
            value-consists-of="LEAF_PRIORITY"
            :disable-branch-nodes="true"
            :default-expand-level="1"
            required
          />
        </div>
        <div
          class="mx-auto mt-2 input-field-container"
          v-if="filterOption === 'other'"
        >
          <treeselect
            v-model="selectedAttributes"
            value-consists-of="LEAF_PRIORITY"
            :default-expand-level="1"
            :options="attributeOptions"
            :load-options="requestLayerAttributes"
            :auto-load-root-options="true"
            :disable-branch-nodes="true"
            :defaultExpandLevel="0"
            :disabled="!selectedLayer"
            required
          />
        </div>

        <div class="search-input-container">
          <v-text-field
            :label="$t('Search')"
            type="text"
            @input="search"
            v-model="searchWord"
            clearable
            :disabled="disableSearch"
            solo
            :loading="loading"
            :messages="disableSearch ? 'Select Layer and Attribute...' : ''"
          >
            <v-icon slot="append">
              search
            </v-icon>
          </v-text-field>
        </div>
      </div>
      <div class="search-container">
      <div class="search-content scroll-fire-fox" id="scroll-bar">
        <div
          class="layer-object-content"
          v-for="place in places"
          :key="place.index"
          @click="
            centerMapFromCoordinatesForm(
              place.geometry.location.lng,
              place.geometry.location.lat
            )
          "
        >
          <div class="object-content-place">
            <span class="layer-label-address">{{ place.name }}</span>
            <div class="object-content-place-info">
              <h4>Address:</h4>
              <span style="width: 160px"> {{ place.formatted_address }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="filterOption === 'other' && searchList.length > 0"
          class="layer-object-content"
        >
          <div class="layer-label">{{ $t(selectedLayer) }}</div>

          <div
            v-for="(objects, index) in searchList"
            :key="index"
            class="object-content"
            @click="centerObjectOnMap(objects.object)"
          >
            <div class="object-id">
              <span class="object-content-label">{{ $t("ID") }}</span>
              <span>{{ getObjectField(objects.object, objects.prefix, "id") }}</span>
            </div>

            <div v-if="selectedLayer !== 'fc_building'" class="object-label">
              <span class="object-content-label"> {{ $tc("Label", 1) }}: </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ getObjectField(objects.object, objects.prefix, "label") }}
                  </span>
                </template>
                <span>{{ getObjectField(objects.object, objects.prefix, "label") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
        <div
          v-for="layer in typeObjectsFound"
          :key="layer.layer"
          v-if="filterOption !== 'other' && layer.objects.length > 0"
          class="layer-object-content"
        >
          <div class="layer-label">{{ $t(layer.layer) }}</div>

          <div
            v-for="(object, index) in layer.objects"
            :key="index"
            class="object-content"
            @click="centerObjectOnMap(object)"
          >
            <div class="object-id">
              <span class="object-content-label">{{ $t("ID") }}</span>
              <span>{{ getObjectField(object, layer.prefix, "id") }}</span>
            </div>

            <div v-if="layer.layer !== 'fc_building'" class="object-label">
              <span class="object-content-label"> {{ $tc("Label", 1) }}: </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ getObjectField(object, layer.prefix, "label") }}
                  </span>
                </template>
                <span>{{ getObjectField(object, layer.prefix, "label") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
        <span v-if="noResultsFound" class="search-content-no-results">
          {{ $t("NoResults") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CloseWindowSVG from "@/assets/sidebar/closeWindowArrow.svg";
import CenterSVG from "@/assets/map_icons/center_workspace.svg";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { mapActions } from "vuex";
import { layersMixin } from "@/mixins/layersMixin";
import AppToggleButtons from "../../../_Atoms/AppToggleButtons.vue";
import axios from "axios";

export default {
  name: "HomeSidebarSearch",

  components: {
    CloseWindowSVG,
    CenterSVG,

    AppToggleButtons
  },

  mixins: [layersMixin, activitiesTasksDataMixin],

  data() {
    return {
      filterOption: "id",
      searchWord: "",
      selectedLayer: null,
      selectedAttributes: null,
      attributeList: {},
      loading: false,
      timeout: null,
      requests: [],
      request: null,
      /**
       * results from id or label search
       */
      typeObjectsFound: [],
      searchList: [],
      /**
       * results from Places Search
       */
      places: [],
      /**
       * list of options returned from requestLayerAttributes
       */
      options: {
        attributes: [],
        custom_fields: [],
        extra_fields: []
      },
      offset: 25
    };
  },
  mounted(){
    document.getElementById('scroll-bar').addEventListener('scroll', this.handleScroll);
  },
  watch: {
    /**
     * when changing layer, attributes and search word, clear, and request for new layer list is made.
     */
    selectedLayer() {
      this.selectedAttributes = null;
      this.searchWord = "";
      this.requestLayerAttributes();
      this.clear();
    },
    /**
     * search exxecutes when user changes the selected attribute, if user clears selected atribute search word gets erased
     */
    selectedAttributes(value) {
      if (value) {
        this.search();
      } else {
        this.searchWord = "";
      }
    },
    /**
     * clears search word, and clears results when changing option
     */
    filterOption() {
      this.searchWord = "";
      this.clear();
    },
  },
  computed: {
    disableSearch() {
      return this.filterOption === "other" && !this.selectedAttributes;
    },
    isInputEmpty() {
      return this.searchWord === "";
    },

    /**
     * renders Object type options in tree select
     */
    typeOptions() {
      let selectedOptions = [];

      this.objectTypeOptions.forEach(element => {
        if (
          element.layer !== "fc_workpoint" &&
          element.layer !== "field_workorders" &&
          element.layer !== "fc_technical_local_fdp" &&
          element.layer !== "fc_technical_local_olt" &&
          element.layer !== "fc_technical_local_site"
        ) {
          selectedOptions.push({ id: element.layer, label: element.type_name });
        }
      });

      selectedOptions.splice(
        this.objectTypeOptions.findIndex(option => option.layer === "fc_technical_local_fdp"),
        0,
        { id: "fc_technical_local", label: this.$i18n.tc("TechnicalLocal", 2) }
      );

      return [
        {
          id: "layer",
          label: this.$tc("Layer"),
          children: selectedOptions
        }
      ];
    },

    /**
     * sets Tree select parent item id and name with its child nodes retrieved from requestlayerattributes
     */
    attributeOptions() {
      let attributeOptions = [];

      if (this.options.attributes && this.options.attributes.length > 0) {
        attributeOptions.push({
          id: "attributes",
          label: this.$i18n.tc('Attributes',1),
          children: this.options.attributes
        });
      }

      if (this.options.custom_fields && this.options.custom_fields.length > 0) {
        attributeOptions.push({
          id: "custom_fields",
          label: this.$i18n.tc('CustomFields',1),
          children: this.options.custom_fields
        });
      }

      if (this.options.extra_fields && this.options.extra_fields.length > 0) {
        attributeOptions.push({
          id: "extra_fields",
          label: this.$i18n.tc('ExtraFields',1),
          children: this.options.extra_fields
        });
      }
      return attributeOptions;
    },

    /**
     * Array of buttons to choose between search filters
     */
    toggleButtons() {
      return [
        {
          value: "id",
          text: "ID",
          disabled: this.loading
        },
        {
          value: "label",
          text: "Label",
          disabled: this.loading
        },
        {
          value: "place",
          text: "Place",
          disabled: this.loading
        },
        {
          value: "other",
          text: "Other",
          disabled: this.loading
        }
      ];
    },

    noResultsFound() {
      let noObjects = true;
      if(this.typeObjectsFound){
        this.typeObjectsFound.forEach(type => {
          if (type.objects.length > 0) {
            noObjects = false;
          }
        });
        if (this.places.length > 0) {
          noObjects = false;
        }

        return noObjects && !this.isInputEmpty && !this.loading;
      }
    }
  },

  methods: {
    ...mapActions([
      "SEARCH_OBJECTS_BY_WORD",
      "SET_OBJECT_TO_ZOOM_ON_MAP",
      "SEARCH_PLACE_BY_WORD",
      "GET_LAYER_ATTRIBUTES",
      "SEARCH_OBJECTS_BY_ATTRIBUTE"
    ]),
    handleScroll(){
      if(this.filterOption === "other"){
        const scrollTop = document.getElementById('scroll-bar').scrollTop;
        const scrollHeight = document.getElementById('scroll-bar').scrollHeight;
        const containerHeight = document.getElementById('scroll-bar').offsetHeight;
        if(containerHeight + scrollTop + 1 >= scrollHeight){
          if(!this.loading){
            this.search();
            this.offset += 25;
          }
        }
      }
    },
    /** Emits an event to close the search window **/
    closeSearch() {
      this.$emit("close");
    },

    /** Allows case-insensitive search of nodes **/
    // cancel token is used to cancel the request if user continues typing to avoid multiple requests and data descrepancy
    search() {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (!this.searchWord) {
        this.clear();
        return;
      }

      clearTimeout(this.timeout);
      if (this.request) this.cancel();
      this.loading = true;
      if (this.loading) {
        this.places = [];
        this.typeObjectsFound = [];
      }

      this.timeout = setTimeout(() => {
        if (this.searchWord === "") {
          this.clear();
          return;
        }

        this.request = { cancel: source.cancel };

        let activeLayerNames = this.getActiveLayersNamesList(
          JSON.parse(sessionStorage.getItem("active_layers"))
        );
        if (this.filterOption === "place") {
          const data = {
            code: "GOOGLE_PLACES",
            body: {
              input: this.searchWord,
              inputtype: "textquery",
              fields: "formatted_address,name,geometry"
            },
            cancelToken: source.token,
            method: "GET"
          };
          this.SEARCH_PLACE_BY_WORD(data)
            .then(data => {
              this.places = data.data.data.results;
              this.clearOldRequest();
              this.loading = false;
            })
            .catch(err => {
              if (!err.__CANCEL__) {
                this.$toasted.global.toast_error(err);
              }
            });
        } else if (this.filterOption === "other") {
          this.SEARCH_OBJECTS_BY_ATTRIBUTE({
            layer: this.selectedLayer,
            filter: this.selectedAttributes,
            value: this.searchWord,
            paginate: 25,
            signalAbort: source.token,
            paginate: String(this.offset),
            globalSearch: false
          })
            .then(typeObjectsFound => {
              const itemsArray = [];
              const prefix = typeObjectsFound.data.data[0].prefix;
              typeObjectsFound.data.data[0].objects.forEach(item =>{
                itemsArray.push(
                  {
                    prefix,
                    object: {...item}
                  }
                )
              });
              if(typeObjectsFound.data.data[0].objects.length >= 1){
                //get first index of new objects fetched
                const firstIndex = Math.floor(((typeObjectsFound.data.data[0].objects.length/25)-1)*25);
                this.clear();
                for(let i = firstIndex; i < itemsArray.length; i++){
                  if (itemsArray[i]) {
                    this.searchList.push(itemsArray[i]);
                  }
                }
              }else{
                this.searchList = [...itemsArray];
              }
              this.typeObjectsFound = typeObjectsFound.data.data;
              this.clearOldRequest();
              this.loading = false;
            })
            .catch(err => {
              if (!err.__CANCEL__ && err.response.status !== 404) {
                this.$toasted.global.toast_error(err);
              }
              this.noResults();
            });
        } else {
          this.SEARCH_OBJECTS_BY_WORD({
            searchFor: this.filterOption,
            word: this.searchWord,
            layers: { layers: activeLayerNames },
            signalAbort: source.token
          })
            .then(typeObjectsFound => {
              this.typeObjectsFound = typeObjectsFound.data.data;
              this.clearOldRequest();
              this.loading = false;
            })
            .catch(() => {
              this.noResults();
            });
        }
      }, 500);
    },

    // clears request made before the new one
    clearOldRequest() {
      this.requests.push(this.request);
      this.request = null;
      this.requests = [];
    },
    //cancels the request made before the new one
    cancel() {
      this.request.cancel();
      this.clearOldRequest("Cancelled");
    },

    clearInput() {
      this.searchWord = "";
      this.clear();
    },

    /** Clears the input in the search box **/
    clear() {
      this.noResults();
    },

    noResults() {
      this.typeObjectsFound = [];
      this.places = [];
      this.searchList = [];
      this.offset = 25;
      this.loading = false;
    },

    getObjectField(object, prefix, field) {
      return object[prefix + field];
    },

    /**
     * centers object on map (internal API parameters)
     */
    centerObjectOnMap(object) {
      let objectGeoJson = this.searchObjectField(object, "geo_json");

      this.$nextTick(() => {
        this.SET_OBJECT_TO_ZOOM_ON_MAP(undefined).then(() => {
          this.SET_OBJECT_TO_ZOOM_ON_MAP(objectGeoJson);
        });
      });
    },

    /**
     * Centers object on map (google API)
     */
    centerMapFromCoordinatesForm(lng, lati) {
      let lat = parseFloat(lati);
      let long = parseFloat(lng);

      let position = [long, lat];

      let pointJson = {
        type: "Point",
        coordinates: position
      };
      position = JSON.stringify(pointJson);
      this.$nextTick(() => {
        this.SET_OBJECT_TO_ZOOM_ON_MAP(undefined).then(() => {
          this.SET_OBJECT_TO_ZOOM_ON_MAP(position);
        });
      });
      this.isActive = true;
    },

    searchObjectField(object, field) {
      for (const [key, value] of Object.entries(object)) {
        if (typeof value === "object" && value !== null) {
          let fieldFounded = this.searchObjectField(value, field);
          if (fieldFounded) return fieldFounded;
        }
        if (key.includes(field) && value) {
          return value;
        }
      }
    },
    /**
     * Assigns fetched result into an object array with id and label to be used in computed property for tree select.
     */
    async requestLayerAttributes() {
      try {
        this.options.attributes = [];
        this.options.extra_fields = [];
        this.options.custom_fields = [];
        if (this.selectedLayer) {
          this.attributeList = await this.GET_LAYER_ATTRIBUTES({
            layer: this.selectedLayer
          });

          this.attributeList.attributes.forEach(item => {
            this.options.attributes.push({
              id: "attributes:" + item,
              label: this.formatText(item)
            });
          });
          this.attributeList.custom_fields.forEach(item => {
            this.options.custom_fields.push({
              id: "custom_fields:" + item.label,
              label: item.label
            });
          });
          this.attributeList.extra_fields.forEach(item => {
            this.options.extra_fields.push({
              id: "extra_fields:" + item,
              label: this.formatText(item)
            });
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * @param {String} item - attributes unformated label
     * @returns {String} - Formated Label with capital letters
     */
    formatText(item) {
      let label = item;
      if (item.includes("_")) {
        label = label.slice(2).replace(/_/g, " ");
      }
      label = label.split(" ");
      for (let i = 0; i < label.length; i++) {
        label[i] = label[i].charAt(0).toUpperCase() + label[i].slice(1);
      }
      return label.join(" ");
    },

    /**
     * Normalizes options for tree select component
     */
    objectTypeNormalizer(node) {
      return {
        id: node.id,
        label: node.label
      };
    }
  }
};
</script>

<style scoped>
.object-content-place {
  font-size: 12px;
  border-bottom: 1px solid #e2e2e2;
  margin: 3px 0;
  display: grid;
  position: relative;
}
.object-content-place-info {
  padding-left: 20px;
  display: grid;
  position: relative;
}
.layer-label-address {
  width: 100%;
  font-family: Lato;
  background-color: #6cb0c2;
  color: white;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: uppercase;
  padding-left: 10px;
}
.bigSidebarWindow {
  width: 250px;
  height: calc(100% - 24px - 40px);
  padding-bottom: 0px;
}
.sidebarWindowTitle {
  width: auto;
}
.input-field-container {
  width: 96%;
  text-align: left;
  font-size: 12px;
}

.layer-object-content {
  text-align: left;
  margin-top: 10px;
  width: 100%;
  cursor: pointer;
  user-select: none;
}

.search-input-container >>> .v-input__slot {
  border: 1px solid #e2e2e2;
  min-height: 10px !important;
  box-shadow: none !important;
}

.search-input-container >>> input:disabled {
  background: #f9f9f9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/SideBar/SidebarWindows/Search.vue